import React, { useEffect, useState } from 'react';
import ResultCard from './ResultCard';
import { useSelector, useDispatch } from 'react-redux';




const Step4Results = ({ onBack, setStep }) => {
    const finalResultData = useSelector((state) => state.analysisData.finalResultData);
    const stepOneformData = useSelector((state) => state.analysisData.stepOneformData);
    const algoFormData = useSelector((state) => state.analysisData.algoFormData);


    const [selectedCombo, setSelectedCombo] = useState(2); // default to 2-item combinations
    const [filterCriterion, setFilterCriterion] = useState('confidence'); // default to 'confidence'
    const [filterValue, setFilterValue] = useState(0.8); // default filter value for confidence
    const [filteredResults, setFilteredResults] = useState([])
    const [selectedDesign, setSelectedDesign] = useState(1);



    useEffect(() => {
        //   Filter the results based on the selected criterion
        // let filteredResults = finalResultData.data.filter(result => {
        //     if (filterCriterion === 'confidence') {
        //         return result.confidence >= filterValue;
        //     }
        //     if (filterCriterion === 'lift') {
        //         return result.lift >= filterValue;
        //     }
        //     if (filterCriterion === 'support') {
        //         return result.support >= filterValue;
        //     }
        //     return true; // fallback case
        // });
        let filteredResults = finalResultData.data.filter(result => {
            let antecedentsLength = result.antecedents.length
            let consequentsLength = result.consequents.length
            let totalLength = antecedentsLength + consequentsLength
            if (selectedCombo !== 0 && selectedCombo === totalLength) {
                return true
            }
            if (selectedCombo === 0) {
                return true
            }
        })
        setFilteredResults(
            filteredResults
        )

    }, [selectedCombo, filterCriterion, filterValue])

    // const handleExportCSV = () => {
    //     const rows = filteredResults;
    //     const header = [
    //         'Antecedents',
    //         'Consequents',
    //         'Support',
    //         'Confidence',
    //         'Lift',
    //         'Antecedent Support',
    //         'Consequent Support',
    //         'Strength'
    //     ];


        


    //     const csvContent = [
    //         header.join(','),
    //         ...rows.map(r =>
    //             [
    //                 `"${[...r.antecedents].join(' + ')}"`,
    //                 `"${[...r.consequents].join(' + ')}"`,
    //                 `${(r.support * 100).toFixed(2)}%`,
    //                 `${(r.confidence * 100).toFixed(0)}%`,
    //                 r.lift.toFixed(2),
    //                 `${(r.antecedent_support * 100).toFixed(2)}%`,
    //                 `${(r.consequent_support * 100).toFixed(2)}%`,

    //                 r.confidence === 1 ? 'strong' : r.confidence > 0.6 ? 'moderate' : 'weak'
    //             ].join(',')
    //         )
    //     ].join('\n');

    //     const blob = new Blob([csvContent], { type: 'text/csv' });
    //     const url = window.URL.createObjectURL(blob);
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.download = `analysis_results_${selectedCombo}_items.csv`;
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // };

    const handleExportCSV = () => {
        const rows = filteredResults;
        const header = [
            'Antecedents',
            'Consequents',
            'Support',
            'Confidence',
            'Lift',
            'Antecedent Support',
            'Consequent Support',
            'Strength'
        ];
    
        const csvContent = [
            header.join(','),
            ...rows.map(r =>
                [
                    `"${r.antecedents.map(a => a.product_title).join(' + ')}"`,
                    `"${r.consequents.map(c => c.product_title).join(' + ')}"`,
                    `${(r.support * 100).toFixed(2)}%`,
                    `${(r.confidence * 100).toFixed(0)}%`,
                    r.lift.toFixed(2),
                    `${(r.antecedent_support * 100).toFixed(2)}%`,
                    `${(r.consequent_support * 100).toFixed(2)}%`,
                    r.confidence === 1 ? 'strong' : r.confidence > 0.6 ? 'moderate' : 'weak'
                ].join(',')
            )
        ].join('\n');
    
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `analysis_results_${selectedCombo}_items.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    


    return (
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-200">
            <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
                <h2 className="text-2xl font-semibold text-gray-800 flex items-center">
                    <i className="fas fa-chart-bar mr-3 text-indigo-600" /> Market Basket Analysis Results
                </h2>
                <div className="flex items-center gap-3">
                    {/* <select
                        value={selectedCombo}
                        onChange={(e) => setSelectedCombo(Number(e.target.value))}
                        className="border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-400"
                    >
                        <option value={2}>2-item combinations</option>
                        <option value={3}>3-item combinations</option>
                        <option value={4}>4-item combinations</option>
                        <option value={0}>All-item combinations</option>
                    </select> */}

                    {/* <select
            value={filterCriterion}
            onChange={(e) => setFilterCriterion(e.target.value)}
            className="border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-400"
          >
            <option value="confidence">Confidence</option>
            <option value="lift">Lift</option>
            <option value="support">Support</option>
          </select> */}

                    {/* <input
            type="number"
            value={filterValue}
            onChange={(e) => setFilterValue(Number(e.target.value))}
            className="border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-400"
            step="0.01"
            min="0"
            max="1"
          /> */}

                    {/* <button
                        onClick={handleExportCSV}
                        className="bg-white border border-indigo-500 text-indigo-600 px-4 py-2 rounded-lg flex items-center hover:bg-indigo-50 transition"
                    >
                        <i className="fas fa-download mr-2" /> Export CSV
                    </button> */}
                </div>
            </div>
            <div class="mb-8">
                <div class="flex flex-wrap gap-4 mb-6">
                    <div class="bg-indigo-50 text-indigo-800 px-4 py-2 rounded-full text-sm font-medium">
                        <i class="fas fa-store mr-1"></i> {stepOneformData.SHOPIFY_SHOP}
                    </div>
                    {/* <div class="bg-gray-100 text-gray-800 px-4 py-2 rounded-full text-sm font-medium">
                        <i class="fas fa-calendar-alt mr-1"></i> {stepOneformData.FROM_DATE} - {stepOneformData.END_DATE}
                    </div> */}
                    <div class="bg-gray-100 text-gray-800 px-4 py-2 rounded-full text-sm font-medium">
                        <i class="fas fa-calculator mr-1"></i> {algoFormData.ALGORITHM} Algorithm
                    </div>
                    <div class="bg-gray-100 text-gray-800 px-4 py-2 rounded-full text-sm font-medium">
                        <i class="fas fa-percentage mr-1"></i> Min Support: {(algoFormData.MIN_SUPPORT * 100)}%
                    </div>
                </div>

                <div class="bg-green-50 border border-green-200 rounded-lg p-4">
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <i class="fas fa-check-circle text-green-500 mt-1"></i>
                        </div>
                        <div class="ml-3">
                            <h3 class="text-sm font-medium text-green-800">Analysis Complete</h3>
                            <div class="mt-2 text-sm text-green-700">
                                <p>Processed <span class="font-bold">{finalResultData.ordersFetched} orders</span> with <span class="font-bold">{finalResultData.transactionsSaved} products</span>. Found <span class="font-bold">{finalResultData.rules_result} significant itemsets</span>.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-8">
                <div class="flex justify-between items-center mb-4">
                    <h3 class="text-lg font-medium text-gray-800">Top Product Associations</h3>
                    <div class="flex space-x-2">
                        <button class="bg-white border border-gray-300 text-gray-700 px-3 py-1 rounded-md text-sm hover:bg-gray-50" onClick={handleExportCSV}>
                            <i class="fas fa-download mr-1"></i> Export
                        </button>
                        <div class="relative">
                            <select
                                value={selectedCombo}
                                onChange={(e) => setSelectedCombo(Number(e.target.value))}
                                class="appearance-none bg-white border border-gray-300 text-gray-700 pl-3 pr-8 py-1 rounded-md text-sm hover:border-gray-400 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                            >
                                <option value={2}>2-item combinations</option>
                                <option value={3}>3-item combinations</option>
                                <option value={4}>4-item combinations</option>
                                <option value={0}>All-item combinations</option>
                            </select>
                            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                <i class="fas fa-chevron-down text-xs"></i>
                            </div>
                        </div>
                        <div class="relative">
                            <select
                                value={selectedDesign}
                                onChange={(e) => setSelectedDesign(Number(e.target.value))}
                                class="appearance-none bg-white border border-gray-300 text-gray-700 pl-3 pr-8 py-1 rounded-md text-sm hover:border-gray-400 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                            >
                                <option value={1}>Grid Design</option>
                                <option value={2}>Table Design</option>
                            </select>
                            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                <i class="fas fa-chevron-down text-xs"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid md:grid-cols-2 gap-4 mb-6" id="results-container">
                </div>

                {/* <div class="flex justify-center mt-6">
                    <button class="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-6 rounded-md">
                        Load More Results
                    </button>
                </div> */}
            </div>
            {
                selectedDesign === 1 &&
                <div className="grid md:grid-cols-2 gap-6">
                {filteredResults.map((r, idx) => {
                    return (
                        <ResultCard
                            key={idx}
                            items={[...r.antecedents, ...r.consequents]}
                            support={`${(r.support * 100).toFixed(2)}%`}
                            // support={r.support}

                            confidence={`${(r.confidence * 100).toFixed(0)}%`}
                            lift={r.lift.toFixed(2)}
                            strength={r.confidence === 1 ? 'strong' : r.confidence > 0.6 ? 'moderate' : 'weak'}
                        />
                    )
                })}
            </div>
            }
            {
                selectedDesign === 2 &&
                <div class="overflow-x-auto shadow rounded-lg border border-gray-200">
                <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-100">
                        <tr>
                            <th class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Antecedent</th>
                            <th class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Consequent</th>
                            <th class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Support</th>
                            <th class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Confidence</th>
                            <th class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Lift</th>
                            <th class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Strength</th>

                        </tr>
                    </thead>
                    <tbody id="results-body" class="bg-white divide-y divide-gray-200">
                    {filteredResults.map((r, idx) => {
                    return (
                        <tr class="hover:bg-gray-50 transition duration-150">
                            {/* <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{r.antecedents.join(",")}</td> */}
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                            {r.antecedents.map((a, i) => (
                                <div key={i} className="flex items-center space-x-2 mb-1">
                                    <img src={a.image} alt={a.product_title} className="w-8 h-8 object-cover rounded" />
                                    <span>{a.product_title}</span>
                                </div>
                            ))}
                            </td>

                            {/* <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{r.consequents.join()}</td> */}
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                                {r.consequents.map((c, i) => (
                                <div key={i} className="flex items-center space-x-2 mb-1">
                                    <img src={c.image} alt={c.product_title} className="w-8 h-8 object-cover rounded" />
                                    <span>{c.product_title}</span>
                                </div>
                                ))}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{`${(r.support * 100).toFixed(2)}%`}</td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{`${(r.confidence * 100).toFixed(0)}%`}</td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{r.lift.toFixed(2)}</td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{r.confidence === 1 ? 'strong' : r.confidence > 0.6 ? 'moderate' : 'weak'}</td>

                        </tr>
                    )
                })}
                        {/* <tr class="hover:bg-gray-50 transition duration-150">
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">Item A</td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">Item B</td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">25.00%</td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">80.00%</td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">1.25</td>
                        </tr> */}
                    </tbody>
                </table>
            </div>
            }

            {filteredResults.length === 0 &&
                <div className="grid md:grid-cols-2 gap-6">
                    <h1>No Record Found</h1>
                </div>

            }
            <div className="flex justify-between mt-10">
                {/* <button onClick={onBack} className="text-gray-600 hover:text-gray-800 font-medium py-2 px-4 rounded-md flex items-center transition">
          <i className="fas fa-arrow-left mr-2" /> Back
        </button> */}
                <button onClick={() => { setStep(1) }} className="bg-indigo-600 hover:bg-indigo-700 text-white py-2 px-6 rounded-lg flex items-center transition">
                    Start New Analysis <i className="fas fa-redo ml-2" />
                </button>
            </div>
        </div>
    );
};

export default Step4Results;
